import { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Tooltip,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import { UserRoleComponent } from './user-role.component';
import { roleApiKeyStore } from '../../../api/role-api-key-store';
import { FormAutoCompleteSelectDynamic } from '../../../components/hook-form/form-autocomplete-select.dynamic.component';
import { useAuthorize } from '../../../hooks/use-authorize';
import { UserPermissionName } from '../../../models/user-permission-name';

const styling = {
  dialogTitleStyle: { padding: '16px 24px 0' },
  contentPadding: { paddingTop: '30px' },
};
interface UserRoleDialog {
  name: string;
  open: boolean;
  onSelectedUsers: (users: any[]) => void;
  onClose: (roleCode?: any) => void;
}

export const UserRoleDialog = ({ name, open, onSelectedUsers, onClose }: UserRoleDialog) => {
  const { unregister, getValues } = useFormContext();
  const [roleCode, setUserRoleCode] = useState<string>('');
  const [selectedUser, setSelectedUser] = useState<any[]>(getValues(name) ?? []);
  const [isChildLoading, setChildLoading] = useState<boolean>(false);

  const handleChangeUsers = (role: any) => {
    setUserRoleCode(role?.roleCode ?? '');
  };

  const handleSelectedUsers = (users: any[]) => {
    setSelectedUser(users ?? []);
  };

  const handleClosed = () => {
    unregister('roleName');
    onClose();
  };
  const handleSubmit = () => {
    unregister('roleName');
    onSelectedUsers(selectedUser ?? []);
    onClose();
  };

  const handleChildLoading = (childLoading: any) => {
    setChildLoading(childLoading);
  }

  const isReadOnlyPermission = useAuthorize([UserPermissionName?.READ_ONLY]);

  return (
    <Dialog
      open={open}
      fullWidth={true}
      maxWidth={'lg'}
      // onClose={handleClosed}
      aria-labelledby="dialog-title"
      aria-describedby="dialog-description"
    >
      <DialogTitle id="dialog-title" style={styling.dialogTitleStyle}>
        SELECT USERS
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={handleClosed}
        sx={{
          position: 'absolute',
          right: 10,
          top: 3,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <Tooltip title={<Typography variant="body1">Close</Typography>}>
          <CloseIcon />
        </Tooltip>
      </IconButton>
      <DialogContent dividers style={styling.contentPadding} className="popupDilog">
        <Grid container spacing={2}>
          <Grid item lg={4} sm={4} xl={4} xs={4}>
            <FormAutoCompleteSelectDynamic
              name="roleName"
              label="User Role"
              onChange={handleChangeUsers}
              getQueryKeyConfig={() => roleApiKeyStore.getRoles()}
              optionsValueKey="roleID"
              optionsLabelKey="roleName"
              disabled={isChildLoading}
              required
            />
          </Grid>
          {roleCode && (
            <Grid item lg={12} sm={12} xl={12} xs={12}>
              <UserRoleComponent
                userRoleCode={roleCode ?? ''}
                selectedUsers={selectedUser}
                onChildLoading={handleChildLoading}
                onSelectedUsers={handleSelectedUsers} />
            </Grid>
          )}
        </Grid>
      </DialogContent>
      <div style={{ padding: '5px', paddingLeft: '16px', paddingRight: '16px' }}>
        <DialogActions className="spaceBetween">
          <Button variant="outlined" style={{ width: '130px' }} onClick={handleClosed}>
            Cancel
          </Button>
          <Button onClick={handleSubmit} variant="contained" style={{ width: '130px' }} disabled={isReadOnlyPermission}>
            Save
          </Button>
        </DialogActions>
      </div>
    </Dialog>
  );
};
